import React from 'react';
import { cn } from '@/lib/utils';

export interface SpinnerProps {
  color?: 'current' | 'white' | 'primary' | 'blue';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const colorClasses = {
  current: 'border-current border-t-transparent',
  white: 'border-white border-t-transparent',
  primary: 'border-primary border-t-transparent',
  blue: 'border-blue-600 border-t-transparent',
};

const sizeClasses = {
  sm: 'h-4 w-4 border-2',
  md: 'h-5 w-5 border-2',
  lg: 'h-8 w-8 border-[3px]',
};

const Spinner: React.FC<SpinnerProps> = ({ color = 'white', size = 'md', className }) => {
  return (
    <div 
      className={cn(
        "animate-spin rounded-full",
        colorClasses[color],
        sizeClasses[size],
        className
      )}
    />
  );
};

export default Spinner;
